import Alert from '@pelckmans/elementis/components/alert';
import Button from '@pelckmans/elementis/components/button';
import { useTranslation } from 'react-i18next';
import { Status } from '../SkoreExportModal';

type ExportAlertsProps = {
  hasUserMaterial: boolean;
  hasNoPoints: boolean;
  hasSyncedResults: boolean;
  onSubmit: () => void;
  status: Status;
};

const BASE = 'PAGES.RESULTS.MODALS.SMARTSCHOOL_SKORE_EXPORT.ALERTS';

function ExportAlerts({ status, hasUserMaterial, hasNoPoints, hasSyncedResults, onSubmit }: ExportAlertsProps) {
  const { t } = useTranslation();
  return (
    <>
      {status === 'failed' && (
        <Alert
          prominence="danger"
          actions={{
            'aria-label': undefined,
            role: undefined,
            children: (
              <Button prominence="danger" onClick={onSubmit}>
                {t('ACTIONS.RESEND')}
              </Button>
            ),
          }}
        >
          {t(`${BASE}.EXPORT_FAILED`)}
        </Alert>
      )}
      {status === 'invalid' && <Alert prominence="warning">{t(`${BASE}.INVALID_SELECTION`)}</Alert>}
      {hasSyncedResults && <Alert prominence="warning">{t(`${BASE}.ALREADY_SYNCED`)}</Alert>}
      {hasNoPoints && <Alert>{t(`${BASE}.NO_POINTS`)}</Alert>}
      {hasUserMaterial && <Alert>{t(`${BASE}.USER_MATERIAL`)}</Alert>}
    </>
  );
}

export default ExportAlerts;
